export * from '@primeuix/themes/material/tieredmenu';
export { default } from '@primeuix/themes/material/tieredmenu';
